<template>
    <div class="page page-detail">
        <div
            class="sub"
            v-if="company"
        >
            <div class="smooth-shadow">
                <div class="name">
                    <img :src="company.logo">
                    <div>
                        <div>{{company.projectName}}</div>
                    </div>
                </div>
                <div class='tags-list-container'>
                    <span
                        class='tag-box'
                        v-for="item in company.tags"
                        :key="item.id"
                    >
                        #{{item.name}}
                    </span>
                </div>
                <div class="jy">
                    <span>{{'交易'|language}}</span>
                    <a
                        class="waves-effect waves-red btn white red-text text-lighten-1"
                        @click.stop="actionBuy(1)"
                    >{{'买'|language}}</a>
                    <a
                        class="waves-effect waves-red btn white red-text text-lighten-1"
                        @click.stop="actionBuy(2)"
                    >{{'卖'|language}}</a>
                </div>
                <div class="txt">{{company.companyDesp}}</div>
                <div
                    class="ke-jy"
                    v-if="company.availableAmounts"
                >
                    {{'可交易'|language}}
                    <template v-if='!en'>
                        <span class="red-text text-darken-1">>&nbsp;{{company.businessType | value-type-businessType}}{{company.availableAmounts}}万</span>
                    </template>
                    <template v-else>
                        <span
                            v-if='company.enAvailableAmount'
                            class="red-text text-darken-1"
                        >>&nbsp; {{company.businessType | value-type-businessType}}{{company.enAvailableAmounts |w2e}} </span>
                        <span
                            v-else
                            class="red-text text-darken-1"
                        >>&nbsp; {{company.businessType | value-type-businessType}}{{company.availableAmounts |w2e}} </span>
                    </template>
                </div>
            </div>
            <!-- <div class="smooth-shadow" style="margin-top: 20px;">
                 <div class="user-my">
                    <img src="http://static.unicornselected.com/b68bb010-0335-11eb-91c5-d550a48abe82.png" alt="">
                    <div class="phone">18801971372</div>
                </div> 
                <div>
                    <a class="waves-effect menu-item" :class="menuIndex == 0 ? 'active' : ''" href="companylist?menuIndex=0">
                        可交易
                        <i class="material-icons">done</i>
                    </a>
                    <a class="waves-effect menu-item" :class="menuIndex == 1 ? 'active' : ''" href="companylist?menuIndex=1">
                        我的收藏
                        <i class="material-icons">done</i>
                    </a>
                    <a class="waves-effect menu-item" :class="menuIndex == 2 ? 'active' : ''" href="companylist?menuIndex=2">
                        我的需求
                        <i class="material-icons">done</i>
                    </a>
                </div>
            </div> -->
            <div
                class="smooth-shadow"
                style="margin-top: 20px;"
            >
                <div>
                    <div class="xinwen-title">
                        <img
                            src="http://static.unicornselected.com/FgedN69ps0BxQ4yJ2c8QUVKhZPv0"
                            alt
                        >
                        <span>{{'最新资讯'|language}}</span>
                    </div>
                    <div
                        class="waves-effect menu-item-news"
                        @click="showPassage(item,index)"
                        v-for="(item, index) in passage"
                        :key="index"
                        :class="menuIndex == 1 ? 'active' : ''"
                    >
                        <i class="material-icons">brightness_1</i>
                        <span>{{item.title}}</span>
                    </div>
                    <div
                        v-if="showFetchMoreBtn"
                        @click="fetchMore"
                        class="load-many"
                    >
                        <span>{{'更多'|language}}</span>
                        <img
                            src=" http://static.unicornselected.com/FlwqDHkVwUVpKEd8S9PLhi__4Bgr"
                            alt
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="detail">
            <div
                class="smooth-shadow"
                v-if="chartData"
            >
                <div class="title">
                    <a class="waves-effect waves-light btn red left">
                        <i class="material-icons left">send</i>{{'估值图表'|language}}
                    </a>
                </div>
                <ve-line
                    :legend-visible="false"
                    :settings="chartSettings"
                    :data="chartData"
                    :colors="['#e0325a']"
                ></ve-line>
            </div>
            <div
                class="smooth-shadow"
                style="margin-top: 20px;"
            >
                <div class="title left">
                    <a class="waves-effect waves-light btn red">
                        <i class="material-icons left">attach_money</i>{{'融资历史'|language}}
                    </a>
                </div>
                <div class="right">
                    <div class="switch switch-title">
                        <span>{{'交易币种'|language}}：</span>
                        <label>
                            <span
                                class="rmb"
                                :class="!check ? 'check1' : ''"
                            >{{'美元'|language}}</span>
                            <input
                                type="checkbox"
                                v-model="check"
                            >
                            <span class="lever"></span>
                            <span
                                class="rmb"
                                :class="check ? 'check2' : ''"
                            >{{'人民币'|language}}</span>
                        </label>
                    </div>
                </div>
                <div class="clear"></div>
                <table class="highlight centered">
                    <thead>
                        <tr>
                            <th>{{'轮次'|language}}</th>
                            <th> {{'融资日期'|language}}</th>
                            <th>{{'融资金额'|language}}({{pkey | value-type}}）</th>
                            <th>{{'投后估值'|language}}({{pkey | value-type}}）</th>
                            <th>{{'投资者'|language}}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="item in rongzisReverse"
                            :key="item.id"
                        >

                            <td>{{item.lunci ? item.lunci.text : '未披露'|language}}</td>
                            <td>{{item.date}}</td>
                            <td v-if="item.rz">
                                {{ item.rz[pkey] | w2e}}
                            </td>
                            <td v-if="item.gz">{{item.gz[pkey] | w2e}}</td>
                            <td style="width: 300px;">
                                <span
                                    v-for="inv in item.investors"
                                    :key="inv.id"
                                >{{inv.name}},&nbsp;&nbsp;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="clear"></div>
        <buy
            ref="buy"
            :company="company"
        />

        <div
            class="dialog-box"
            v-show="show"
            @click.stop="show = false"
        >
            <transition name="buy">
                <div
                    class="content"
                    v-if="show"
                    @click.stop
                >
                    <div class='header'>
                        <img
                            src="http://static.unicornselected.com/Fqh0gi1FLvh-nFAFCsFWvpGOJkAW"
                            class="logo"
                        >
                        <div class="xw-title">
                            <div class="t1">{{xinwen.title}}</div>
                            <div class="t2">{{xinwen.author}}&nbsp;&nbsp;&nbsp;&nbsp;{{xinwen.date | fmt-date}}</div>
                        </div>
                    </div>
                    <i
                        class="iconfont icon-guanbi"
                        @click.stop="show=false"
                    ></i>
                    <div class="html-passage">
                        <div v-html="xinwen.html"></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { HttpClient } from '../util/http';
import { w2e, velineW2e } from '../util/danwei';
import Buy from '../components/Buy';
import { userInstance } from '../util/user.js';
import { defaultbus } from '../util/bus';
import dayjs from 'dayjs';
export default {
    inject: ['reload'],
    components: {
        VeLine,
        Buy,
    },
    data() {
        return {
            company: null,
            rongzis: [],
            transfer: 0,
            check: false,
            menuIndex: -1,
            fatherData: null,
            show: false,
            form: {},
            loading: false,
            xinwen: null,
            sss: null,
            passage: null,
            isXinWenLimit: true,
            showFetchMoreBtn: true,
        };
    },
    computed: {
        rongzisReverse() {
            return [...this.rongzis].filter(it => it.type != 'space').reverse();
        },
        pkey() {
            return this.check ? 'rmb' : 'dollar';
        },
        chartSettings() {
            let yAxisName =
                location.pathname.indexOf('/en') < 0
                    ? [!this.check ? '美元（亿）' : '人民币（亿）']
                    : [
                          !this.check
                              ? `            dollar (billion)`
                              : `            rmb（billion)`,
                      ];

            return {
                area: true,
                xAxisType: 'time',
                yAxisName,

                itemStyle: {
                    normal: {
                        lineStyle: {
                            color: '#e0325a',
                        },
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#ef9a9a',
                                },
                                {
                                    offset: 1,
                                    color: '#ffcdd2',
                                },
                            ],
                        },
                    },
                },
            };
        },
        chartData() {
            if (!this.rongzis.length) return null;

            if (!this.en) {
                let rows = this.rongzis
                    .filter(it => it.gz[this.pkey] > 0)
                    .map(it => {
                        return {
                            ['时间(Time)']: it.date,
                            ['估值(Valuation)']: velineW2e(it.gz[this.pkey]),
                        };
                    });
                // if (rows.length == 0) {
                //     rows = [
                //         {
                //             ['时间(Time)']: null,
                //             ['估值(Valuation)']: 0,
                //         },
                //     ];
                // }
                // if (rows.length == 1) {
                //     rows.push({
                //         ['时间(Time)']: '2000-1-1',
                //         ['估值(Valuation)']: 0,
                //     });
                // }
                return {
                    columns: ['时间(Time)', '估值(Valuation)'],
                    rows,
                };
            } else {
                let rows = this.rongzis
                    .filter(it => it.gz[this.pkey] > 0)
                    .map(it => {
                        return {
                            ['Time']: it.date,
                            ['Valuation']: velineW2e(it.gz[this.pkey]) / 10,
                        };
                    });

                // if (rows.length == 0) {
                //     rows = [
                //         {
                //             ['Time']: null,
                //             ['Valuation']: 0,
                //         },
                //     ];
                // }

                // if (rows.length == 1) {
                //     rows.push({
                //         ['Time']: '2000-1-1',
                //         ['Valuation']: 0,
                //     });
                // }

                return {
                    columns: ['Time', 'Valuation'],
                    rows,
                };
            }
        },
    },
    created() {
        this.fetchData();
    },

    methods: {
        actionBuy(type) {
            if (!userInstance.user) {
                return defaultbus.$emit('toggle-login');
            }
            this.$refs.buy.toggleBuy(type);
        },
        fetchData() {
            HttpClient.get(`/company/detail?id=${this.$route.query.id}`).then(
                res => {
                    if (res.company.valueType == 1) {
                        this.check = true;
                    }
                    this.company = res.company;

                    this.rongzis = res.rongzis.map(it => {
                        it.date = dayjs(it.date).format('YYYY-MM');
                        return it;
                    });

                    this.transfer = res.transfer;
                    if (this.isXinWenLimit) {
                        res.passage.splice(10);
                        this.passage = res.passage;
                    } else {
                        this.passage = res.passage;
                    }
                },
            );
        },
        showPassage(data, index) {
            this.xinwen = data;
            this.show = true;

            HttpClient.post('/restful', {
                model: 'Passage',
                cond: data._id,
            }).then(res => {
                this.xinwen = res.result;
            });
        },
        fetchMore() {
            this.isXinWenLimit = false;
            this.showFetchMoreBtn = false;
            this.fetchData();
        },
    },
};
</script>

<style scoped lang="less">
@import '../assets/head-item.less';
.menu-item-news {
    min-height: 48px;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    i {
        font-size: 8px;
    }
    span {
        text-align: left;
        margin-left: 10px;
    }
}

.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.content {
    width: 1000px;
    border-radius: 2px;
    background: white;
    transform-origin: 50%, 50%;
    position: relative;

    .header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #dfdfdf;
        .logo {
            height: 90px;
            width: 200px;
        }
        .xw-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .t1 {
                color: black;
                font-size: 20px;
                white-space: pre-line;
                width: 750px;
                text-align: left;
            }
            .t2 {
                text-align: right;
                font-size: 15px;
                color: #c0c0c0;
            }
        }
    }

    > h5 {
        margin: 0 auto;
    }
    .icon-guanbi {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
    }
    .html-passage {
        overflow-y: auto;
        height: 800px;
        height: 70vh;
        padding: 0 20px;
        width: 100%;
        img {
            max-width: 100%;
            height: auto;
        }
    }
}
.buy-enter-active,
.buy-leave-active {
    transition: all ease 0.5s;
}
.buy-enter,
.buy-leave-to {
    transform: scale(0);
    opacity: 0;
}
.xinwen-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid rgb(234, 234, 234);
    height: 40px;
    > img {
        width: 15px;
        margin-left: 33px;
    }
    > span {
        margin-left: 5px;
    }
}

.load-many {
    cursor: pointer;
    height: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 20px 0;
    > span {
        font-size: 13px;
        color: rgba(102, 102, 102, 1);
    }
    > img {
        width: 25px;
    }
    &:active {
        background-color: rgba(224, 221, 221, 0.2);
        opacity: 0.8;
    }
}

.page-detail {
    padding-top: 30px;
    padding-bottom: 30px;
    .detail {
        width: 960px;
        margin-left: 40px;
        float: left;
        .title {
            font-weight: bold;
            padding: 20px 0;
            font-size: 17px;
            margin-bottom: 40px;
        }
        .switch-title {
            margin-top: 25px;
            margin-right: 20px;
            span {
                font-weight: bold;
                font-size: 16px;
                line-height: 24px;
            }
            .check1 {
                color: #ffab00;
            }
            .check2 {
                color: #bc242b;
            }
        }
    }
    .sub {
        width: 300px;
        float: left;
        .name {
            display: flex;
            height: 80px;
            align-items: center;
            justify-content: center;
            > img {
                border-radius: 50%;
                margin-right: 5px;
                height: 40px;
            }
        }
        .tags-list-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 0px 10px 5px 10px;
            .tag-box {
                font-size: 12px;
                margin-bottom: 8px;
                margin-right: 10px;
                font-weight: 900;
                padding: 3px 10px;
                border-radius: 30px;
                display: inline-block;
                background-color: #f9dfd0;
                color: #ff7e40;
            }
        }
        .jy {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: orange;
            color: white;
            > a {
                margin-left: 10px;
            }
        }
        .txt {
            padding: 5px 15px;
            font-size: 13px;
            text-align: left;
            line-height: 22px;
        }
        .ke-jy {
            text-align: center;
            font-size: 17px;
            padding: 10px 0 15px 0;
        }
    }
}
</style>
